import SurveySectionApi from '@/services/api/admin/SurveySectionApi'

export default {
	/**
	 * Get survey templates 
	 */
	async all ({ commit }, templates) {
		try {
			const templates = await SurveySectionApi.all()
			commit('setAll', templates)
		} catch (err) {
			throw err
		}
	},
	/**
	 * Get requested survey template 
	 * @param {String} 
	 */
	async show ({ commit, dispatch }, id) {
		commit('setFetching', true)
		try {
			const template = await SurveySectionApi.show(id)
			dispatch('showing/setSurveyData', template)
		} catch (err) {
			console.log(err)
		} finally {
			commit('setFetching', false)
		}
	},
	/**
	 * set true if survey is being requested and false after response 
	 * @param {Boolean} isFetching
	 */
	setFetching ({ commit }, isFetching) {
		commit('setFetching', isFetching)
	},
	/**
	 * Delete survey  template
	 * @param {String} id
	 */
	async remove ({ commit }, id) {
		try { 
			return await SurveySectionApi.delete(id)
		} catch (err) {
			console.log(err)
		}	
	},
}
